module.exports = __webpack_public_path__ + "static/media/JRR.2d921479.png";